import userReducer from './userReducer';

export const mainUserReducer = {
  user: userReducer,
};
